export default {
  email: [
    v => !!v || 'Email jest wymagany',
    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) || 'Email musi być poprawny',
    v => (v && v.length >= 6) || 'Email musi mieć minimalnie 6 znaków',
    v => (v && v.length <= 255) || 'Email może mieć maksymalnie 255 znaków',
  ],
  password: [
    v => !!v || 'Hasło jest wymagane',
    v => (v && v.length >= 8) || 'Hasło musi mieć co najmniej 8 znaków',
    v => /[a-z]+/.test(v) || 'Hasło musi zawierać małą literę',
    v => /[A-Z]+/.test(v) || 'Hasło musi zawierać dużą literę',
    v => /\d+/.test(v) || 'Hasło musi zawierać cyfrę'
  ],
  name: [
    v => !!v || 'Imię jest wymagane',
    v => (v && v.length >= 2) || 'Imię musi mieć co najmniej 2 znaki',
    v => (v && v.length <= 24) || 'Imię może mieć maksymalnie 24 znaków',
  ],
  surname: [
    v => !!v || 'Nazwisko jest wymagane',
    v => (v && v.length >= 2) || 'Nazwisko musi mieć co najmniej 2 znaki',
    v => (v && v.length <= 100) || 'Nazwisko może mieć maksymalnie 100 znaków',
  ],
  phone: [
    v => !!v || 'Telefon jest wymagany',
    v => (v && v.length >= 1) || 'Telefon musi mieć co najmniej 1 znak',
    v => (v && v.length <= 20) || 'Telefon może mieć maksymalnie 20 znaków',
  ],
  title: [
    v => !!v || 'Stanowisko jest wymagane',
    v => (v && v.length <= 255) || 'Stanowisko może mieć maksymalnie 255 znaków',
  ],
  color: [
    v => !!v || 'Kolor jest wymagany',
    v => (v && v.length <= 21) || 'Kolor może mieć maksymalnie 21 znaków',
  ],
}